import { useEscapeLayer } from '@lib/escape'
import { useClickOutside } from '@lib/hooks'
import { selectComments } from '@store/reducers/comments'
import type { Thread } from '@store/reducers/threads'
import {
  clearSelectedThread,
  selectThread,
} from '@storeOld/reducers/canvas/canvas'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { isInsideOverlay, isInsidePopover } from '@/utils'

export const useThreadItem = (thread: Thread, active: boolean) => {
  const dispatch = useDispatch()
  const comments = useSelector(selectComments(thread.uuid))

  const onClick = () => {
    const action = active ? clearSelectedThread() : selectThread(thread.uuid)
    dispatch(action)
  }

  useEscapeLayer(active, () => dispatch(clearSelectedThread()))

  const onClickOutside = (ev: React.MouseEvent) => {
    if (isInsidePopover(ev.target) || isInsideOverlay(ev.target)) {
      return
    }

    dispatch(clearSelectedThread())
  }

  const { ref } = useClickOutside<HTMLDivElement>(
    active,
    onClickOutside,
    (ev) => ev.stopPropagation()
  )

  return { ref, onClick, comments }
}
